import { render, staticRenderFns } from "./ref-notifications.vue?vue&type=template&id=ed042900&scoped=true&lang=pug&"
import script from "./ref-notifications.vue?vue&type=script&lang=js&"
export * from "./ref-notifications.vue?vue&type=script&lang=js&"
import style0 from "./ref-notifications.vue?vue&type=style&index=0&id=ed042900&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed042900",
  null
  
)

export default component.exports